import React, { useEffect } from "react";
import { TagInput } from "rsuite";
import { Uploader } from "rsuite";
import { Button, Upload } from "antd";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { DatePicker } from "rsuite";
import { FaCaretDown } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "English",
  "Hindi",
  "Bengali",
  "Telugu",
  "Marathi",
  "Tamil",
  "Urdu",
  "Gujarati",
  "Kannada",
  "Odia",
  "Malayalam",
  "Punjabi",
  "Assamese",
  "Maithili",
  "Santali",
  "Kashmiri",
  "Nepali",
  "Konkani",
  "Sindhi",
  "Dogri",
  "Manipuri",
  "Bodo",
  "Sanskrit",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

function PatientCareInfo({ formik }) {
  useEffect(() => {
    if (formik.values.dateofbirth) {
      const birthDate = new Date(formik.values.dateofbirth);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();

      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      if (!isNaN(age)) {
        formik.setFieldValue("age", age.toString());
      }
    }
  }, [formik.values.dateofbirth]);

  const multiselectstyles = `
  .css-yi3mkw {
      height: auto;
    min-height: 1.4375em;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    flex-wrap: nowrap;
  }
    .rs-input-group{
  border-radius: 6px;
  height: 40px;
  border-color:1px solid #e5e5ea;
  padding: 0.1rem !important;
  }
 
  `;

  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };
  return (
    <>
      <style>{multiselectstyles}</style>
      <div className="row">
        <div className="col-12 d-flex flex-column align-items-start">
          <div className="col-12 d-flex">
            <h5
              className="fw-semibold h5-WOeTzEASAL"
              style={{ color: "rgb(43, 81, 147)", marginTop: "1rem" }}
            >
              Basic Information
            </h5>
          </div>
        </div>

        {/* <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Patient Id<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder=""
              value={formik.values.patientid}
              name="patientid"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled
            />
            {formik.touched.patientid && formik.errors.patientid && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.patientid}
              </div>
            )}
          </div>
        </div> */}

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Full Name<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Full Name"
              value={formik.values.fullname}
              name="fullname"
              onChange={(e) => {
                const cleanedValue = e.target.value.replace(
                  /[^A-Za-z.\s]/g,
                  ""
                );
                formik.setFieldValue("fullname", cleanedValue);
              }}
              onBlur={formik.handleBlur}
            />

            {formik.touched.fullname && formik.errors.fullname && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.fullname}
              </div>
            )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3" style={{ position: "relative" }}>
            <label className="col-form-label lbl-VLJQLgvYMk">
              Gender<span className="text-danger">*</span>
            </label>
            <div style={{ position: "relative" }}>
              <select
                className="form-control"
                id="Gender"
                aria-hidden="true"
                name="gender"
                value={formik.values.gender}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  paddingRight: "2.5rem",
                  borderRadius: "6px",
                }}
              >
                <option value="">Select the Options</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="others">Others</option>
              </select>

              {/* Dropdown icon */}
              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              />
            </div>

            {formik.touched.gender && formik.errors.gender && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.gender}
              </div>
            )}
          </div>
        </div>

        <div class="col-md-3 col-12">
          <div class="input-block mb-3">
            <label class="col-form-label lbl-VLJQLgvYMk">
              Date of Birth<span className="text-danger">*</span>
            </label>
            <DatePicker
              name="dateofbirth"
              value={
                formik.values.dateofbirth
                  ? new Date(formik.values.dateofbirth)
                  : null
              }
              onChange={(value) => formik.setFieldValue("dateofbirth", value)}
              onBlur={() => formik.setFieldTouched("dateofbirth", true)}
              format="dd-MMM-yyyy"
              placeholder="dd-mmm-yyyy"
              oneTap
              style={{ width: "100%", height: "33px", borderRadius: "4px" }}
            />

            {formik.touched.dateofbirth && formik.errors.dateofbirth && (
              <div
                style={{ fontSize: "0.8rem", color: "red", marginTop: "15px" }}
              >
                {formik.errors.dateofbirth}
              </div>
            )}
          </div>
        </div>

<div className="col-md-3 col-12">
  <div className="input-block mb-3">
    <label className="col-form-label lbl-VLJQLgvYMk">
      E-mail Address
    </label>
    <input
      type="text"
      className="form-control"
      placeholder="Enter E-mail Address"
      value={formik.values.email}
      name="email"
      disabled 
    />
    {formik.touched.email && formik.errors.email && (
      <div style={{ fontSize: "0.8rem", color: "red" }}>
        {formik.errors.email}
      </div>
    )}
  </div>
</div>


        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Age<span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Age"
              value={formik.values.age}
              name="age"
              id="age"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              readOnly
            />
            {formik.touched.age && formik.errors.age && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.age}
              </div>
            )}
          </div>
        </div>

       <div className="col-md-3 col-12">
  <div className="input-block mb-3">
    <label className="col-form-label lbl-VLJQLgvYMk">
      Phone Number
    </label>
   <PhoneInput
  country="in"
  onlyCountries={['in']}
  disableDropdown={true}
  countryCodeEditable={false}
  value={formik.values.phonenumber}
  onChange={(value, country) => {
    formik.setFieldValue('phonenumber', value);
    formik.setFieldValue('countryCode', `+${country.dialCode}`);
  }}
  inputClass="form-control"
  specialLabel="" // Ensures no extra label
/>

    {formik.touched.phonenumber && formik.errors.phonenumber && (
      <div style={{ fontSize: '0.8rem', color: 'red' }}>
        {formik.errors.phonenumber}
      </div>
    )}
  </div>
</div>


        <div className="col-md-3 col-12">
          <div className="input-block mb-3" style={{ position: "relative" }}>
            <label className="col-form-label lbl-VLJQLgvYMk">
              Marital Status<span className="text-danger">*</span>
            </label>

            <div style={{ position: "relative" }}>
              <select
                className="form-control"
                id="martial"
                name="martialstatus"
                value={formik.values.martialstatus}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{
                  appearance: "none",
                  WebkitAppearance: "none",
                  MozAppearance: "none",
                  paddingRight: "2.5rem",
                }}
              >
                <option value="">Select the Options</option>
                <option value="single">Single</option>
                <option value="married">Married</option>
              </select>

              <FaCaretDown
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#666",
                  fontSize: "1rem",
                }}
              />
            </div>

            {formik.touched.martialstatus && formik.errors.martialstatus && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.martialstatus}
              </div>
            )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Emergency Contact Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Emergency Contact Name"
              value={formik.values.emergencycontactname}
              name="emergencycontactname"
              onChange={(e) => {
                const cleanedValue = e.target.value.replace(
                  /[^A-Za-z.\s]/g,
                  ""
                );
                formik.setFieldValue("emergencycontactname", cleanedValue);
              }}
              onBlur={formik.handleBlur}
            />

            {formik.touched.emergencycontactname &&
              formik.errors.emergencycontactname && (
                <div style={{ fontSize: "0.8rem", color: "red" }}>
                  {formik.errors.emergencycontactname}
                </div>
              )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Emergency Contact Number
            </label>

<PhoneInput
  country="in"
  onlyCountries={['in']}
  disableDropdown={true}
  countryCodeEditable={false}
  value={formik.values.emergencycontactnumber}
  onChange={(value, country) => {
    // value includes the country code, e.g. "+911234567890"
    formik.setFieldValue('emergencycontactnumber', value);
    formik.setFieldValue('emergencyContactCountryCode', `+${country.dialCode}`);
  }}
  inputClass="form-control"
  specialLabel="" // Prevents extra label
  placeholder="Enter Emergency Contact Number"
/>


            {formik.touched.emergencycontactnumber &&
              formik.errors.emergencycontactnumber && (
                <div style={{ fontSize: "0.8rem", color: "red" }}>
                  {formik.errors.emergencycontactnumber}
                </div>
              )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">
              Relation to Patient
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Relation to Patient"
              value={formik.values.relationtopatient}
              name="relationtopatient"
              onChange={(e) => {
                const cleanedValue = e.target.value.replace(
                  /[^A-Za-z.\s]/g,
                  ""
                );
                formik.setFieldValue("relationtopatient", cleanedValue);
              }}
              onBlur={formik.handleBlur}
            />

            {formik.touched.relationtopatient &&
              formik.errors.relationtopatient && (
                <div style={{ fontSize: "0.8rem", color: "red" }}>
                  {formik.errors.relationtopatient}
                </div>
              )}
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="input-block mb-3">
            <label className="col-form-label lbl-VLJQLgvYMk">Reffered By</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Relation to Patient"
              value={formik.values.refferedby}
              name="refferedby"
              onChange={(e) => {
                // Remove anything that’s not a letter, dot, or space
                const cleanedValue = e.target.value.replace(
                  /[^A-Za-z.\s]/g,
                  ""
                );
                formik.setFieldValue("refferedby", cleanedValue);
              }}
              onBlur={formik.handleBlur}
            />

            {formik.touched.refferedby && formik.errors.refferedby && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.refferedby}
              </div>
            )}
          </div>
        </div>

        <div class="col-12 col-md-12">
          <div class="mb-3">
            <div className="d-flex align-items-center w-50 gap-2 div-kasxoakxm">
              <label class="col-form-label abt-pr">
                {" "}
                Address<span class="text-danger">*</span>{" "}
              </label>
            </div>
            <textarea
              class="form-control"
              placeholder="Enter Address..."
              style={{
                color: "rgb(66, 66, 66)",
                height: "110px",
                letterSpacing: "0.5px",
                fontSize: "0.9rem",
                padding: "0.8rem",
                lineHeight: "1.7",
              }}
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            ></textarea>

            {formik.touched.address && formik.errors.address && (
              <div style={{ fontSize: "0.8rem", color: "red" }}>
                {formik.errors.address}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default PatientCareInfo;
